import { Injectable } from '@angular/core';

const WIDGET_SRC = 'https://eec-production.up.railway.app/chatbot-widget.js';
const WIDGET_API = 'https://eec-production.up.railway.app/api/chat';

@Injectable({ providedIn: 'root' })
export class ChatbotWidgetService {
  private scriptEl: HTMLScriptElement | null = null;
  private widgetEls: Element[] = [];

  load(initiallyHidden = false, surveyPage = false): void {
    if (this.scriptEl) {
      if (initiallyHidden) { this.hide(); }
      return;
    }

    const before = new Set<Element>(Array.from(document.body.children));

    const script = document.createElement('script');
    script.src = WIDGET_SRC;
    script.setAttribute('data-api', WIDGET_API);
    script.onload = () => {
      this.widgetEls = Array.from(document.body.children)
        .filter(el => !before.has(el) && el !== this.scriptEl);
      if (surveyPage) { this.applyMobileOffset(); }
      if (initiallyHidden) { this.hide(); }
    };
    document.body.appendChild(script);
    this.scriptEl = script;
  }

  private applyMobileOffset(): void {
    const launcher = document.querySelector('.neml-launcher') as HTMLElement;
    const panel = document.querySelector('.neml-panel') as HTMLElement;
    if (launcher) { launcher.style.setProperty('bottom', '150px', 'important'); }
    if (panel)    { panel.style.setProperty('bottom', '70px', 'important'); }
  }

  hide(): void {
    const el = document.querySelector('.neml-chat') as HTMLElement;
    if (el) { el.style.display = 'none'; }
  }

  show(): void {
    const el = document.querySelector('.neml-chat') as HTMLElement;
    if (el) { el.style.display = ''; }
  }

  destroy(): void {
    this.widgetEls.forEach(el => el.remove());
    this.widgetEls = [];
    if (this.scriptEl) {
      this.scriptEl.remove();
      this.scriptEl = null;
    }
  }
}
